import { TextLargeParagraph } from '@carboncopyco/ui';
import { getTimezoneName, useDashboardAnalytics } from '@carboncopyco/utils';
import { useMemo, useState } from 'react';
import { DownloadCsvButton } from '../../../../InfoPage/DownloadCsv';
import { TitleCard } from '../../../../InfoPage/InfoPageCards/TitleCard';
import { useDashboardProps } from '../../../DashboardContext';
import { TableTabs } from '../../../SessionBreakdownComponents';
import type { CsvParams } from '../../../SessionBreakdownComponents/types';
import {
  PresentationsBreakdownTable,
  VisitsBreakdownTable,
} from '../../SessionBreakdownTables';
import { TableContextProvider } from '../../SessionBreakdownTables/TableContext';

export type TableTabTypes = 'presentations' | 'visits';

export const EnvironmentSessionBreakdown = () => {
  const { organizationId } = useDashboardProps();
  const [tableTab, setTableTab] = useState<TableTabTypes>('presentations');
  const { trackDashboardSessionsBreakdownTabsClick } = useDashboardAnalytics();
  const initialCsvParams: CsvParams['params'] = useMemo(
    () => ({
      organizationId,
      resourceTypes: ['managed_presentation', 'play'],
      timezone: getTimezoneName(),
    }),
    [organizationId]
  );

  const [csvParams, setCsvParams] = useState<CsvParams>({
    params: initialCsvParams,
    isDisabled: false,
  });

  return (
    <TableContextProvider tableTab={tableTab}>
      <TitleCard
        radius
        border="ds-regular"
        header={
          <div className="h-ds-15 flex px-6 items-center justify-between">
            <TextLargeParagraph
              label="Session breakdown"
              color="text-ds-natural-600"
            />
            <div className="flex items-center gap-3 ml-auto">
              <TableTabs
                onChange={(index) => {
                  const tableTab = index ? 'visits' : 'presentations';
                  setTableTab(tableTab);
                  setCsvParams({
                    params: {
                      ...initialCsvParams,
                      resourceTypes:
                        tableTab === 'presentations'
                          ? ['managed_presentation', 'play']
                          : ['shared_presentation'],
                    },
                    isDisabled: false,
                  });
                  trackDashboardSessionsBreakdownTabsClick({
                    dashboardTableTab: tableTab,
                  });
                }}
              />
              <DownloadCsvButton
                params={csvParams.params}
                disabled={csvParams.isDisabled}
                location="analytics_page"
              />
            </div>
          </div>
        }
      >
        {tableTab === 'presentations' ? (
          <PresentationsBreakdownTable setCsvParams={setCsvParams} />
        ) : (
          <VisitsBreakdownTable setCsvParams={setCsvParams} />
        )}
      </TitleCard>
    </TableContextProvider>
  );
};
